import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const StatusTagContainer = styled.div(props => ({
  display: 'flex',
  fontFamily: 'IBM Plex Sans Thai',
  fontWeight: 'bold',
  fontSize: '12px',
  color: '#FFF',
  background: props.status ? v.tagColors[(props.isBilling && props.status === 9) ? 2 : props.status] : v.tagDraft,
  width: 'fit-content',
  borderRadius: '10px 0px',
  padding: '0px 12px',
  height: 'fit-content'
}))
